import React from 'react'

function Nachalo() {
    return (
        <section id="main" className="welcome">
  <div className="container">
    <div className="welcome-inner">
      <h1>РАЗРАБОТКА
        ТЕХНОЛОГИЧНЫХ САЙТОВ</h1>
      <div className="buttons">
        <button className="order-site">
          <span>
            заказать сайт 
          </span>
        </button>
      </div>
    </div>
  </div>
</section>

    )
}

export default Nachalo
